/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Not_RegisteredInputs */



/**
* | output |
* | --- |
* | "Player is not registered in this tournament" |
*
* @param {Err_Tournament_Not_RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_not_registered = /** @type {((inputs?: Err_Tournament_Not_RegisteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Not_RegisteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur n'est pas inscrit à ce tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador no está inscrito en este torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador não está inscrito neste torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore non è iscritto a questo torneo")
	return /** @type {LocalizedString} */ ("Player is not registered in this tournament")
});